import React, { useContext, useRef, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { ActionButton, DefaultButton, Dialog, DialogFooter, DialogType, DirectionalHint, IconButton, PrimaryButton, SpinnerSize, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import AprobacionFlujoEdP from './AprobacionFlujoEdP';
import { useCargarVista, useGetEdPPolinomios, useGetEdPResult, useGetEdPResultDI, useGetEdPResultParties } from '../../../hooks/services/sPay/useOfEdPPrepare';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../../components/Templates/Site/Loading';
import SidePanelIngresoEdP from './IngrsoEdP/index';
import './StickyTable.css';
import './revisionIcons.css';
import { __MessageTypes, enum__AppElementType, enum__Clients, enum_ENUM_dIcono_Revision, enum_ENUM_FLUJO_EP, enum_ENUM_ICONO_REVISION, enum_ENUM_TIPO_RESPUESTA } from '../../../common/Dictionaries';
import { base64ToArrayBuffer, convettSignatureDatesToGMTLocal, isNullUndefined, isNullUndefinedOrEmpty, isNullUndefinedOrEmptyOrNegative, isNullUndefinedOrEmptyOrZero, qrToPng, saveByteArray } from '../../../common/Helpers';
import { anulateEdP, deleteEdP, exportEdP, getChecklistEP, revisionEndsEP, revisionEP } from '../../../services/sPay/edpConfig.service';
import MessageBoxInfoComplex from '../../../components/Common/Message/MessageBoxInfoComplex';
import { action_updateEdPPrepareErrorValidations } from '../../../reducers/actions/PAY/edpPrepareActions';
import SidePanelViewEdPPartieComments from './SidePanelViewEdPPartieComments';
import SidePanelViewEdPChecklistNotas from './SidePanelViewEdPChecklistNotas';
import MainAppContext from '../../../MainAppContext';
import ApprovePartieDiDialog from './ApprovePartieDiDialog';
import moment from 'moment';
import { t } from 'i18next';
import { __onGoToBoardEP } from '../../../common/SystemRedirections';
import DynamicRevisionFlujoEdP from './DynamicRevisionFlujoEdP';
import PropTypes from 'prop-types';
import { useGetContractById } from '../../../hooks/services/sBook/useOfContract';
import { cloneDeep } from 'lodash-es';
import { generateAndDownloadPDF } from './PDFDocument/services/pdfService';
import { generateAndDownloadChecklistPDF } from './ChecklistPDF/pdfService';
import { authGetClient } from '../../../actions/auth-action';
import { __GetClientRoleCode } from '../../../common/CommonFuctions';
import ApprovePartieDiPanel from './ApprovePartieDiPanel';
import { useBoolean } from '@fluentui/react-hooks';
import CLabel from '../../../components/Common/CLabel';

const ResultadoEdP = (props) => {
    const dispatch = useDispatch();
    const contextSite = useContext(MainAppContext);

    const {
        _formMode: formMode,
        _firsLoadResult: firsLoadResult,
        _firsLoadParties: firsLoadParties,
        _firsLoadDI: firsLoadDI,
        _edpPrepareResult: edpPrepareResult,
        _edpPrepareDIs: edpPrepareDIs,
        _edpPrepareParties: edpPrepareParties,
        _edpPrepareErrorValidations: edpPrepareErrorValidations,
        _edpPrepareHeader: edpPrepareHeader,
        _edpPrepareManageButtons: edpPrepareManageButtons,
        _forceGet_PrepareResult: forceGet_PrepareResult,
        _forceGet_PrepareParties: forceGet_PrepareParties,
        _forceGet_PrepareButtons: forceGet_PrepareButtons,
    } = useSelector((state) => state.edpPreparationState);

    const { 
        inputParam_ElementId = null,
        inputParam_EdPId = null,
        inputParam_UserPropsKpi = null,
    } = props;

    const _priv_canEditEdP = (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin) && (!isNullUndefined(inputParam_UserPropsKpi) ?  !inputParam_UserPropsKpi.onlyObserver : false);

    // Checklist "Back Office GST" (botón "Exportar checklist" y el panel de notas al "Terminar
    // revisión" de AAD): funcionalidad específica de AMSA, no aplica a otros clientes.
    const esClienteAmsa = authGetClient()?.toLocaleLowerCase() === enum__Clients.AMSA.toLocaleLowerCase();

    const leftTableRef = useRef(null);
    const rightTableRef = useRef(null);
    const [calloutVisibleIndex, setCalloutVisibleIndex] = useState(null);
    const [isDinamicIccLccPanelOpen, setIsDinamicIccLccPanelOpen] = useState(false);
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [isDeleted, setIsDeleted] = useState(false);
    const [isIngresoDatosPanelOpen, setIsIngresoDatosPanelOpen] = useState(false);
    const [isPartieCommentPanelOpen, setIsPartieCommentPanelOpen] = useState(false);
    const [selectedPartieToComment, setSelectedPartieToComment] = useState(null);
    // Este panel ya no tiene botón propio: se abre únicamente interceptando "Terminar revisión" del
    // AAD, y al guardar las notas siempre encadena esa acción (ver onTerminarRevisionClick).
    const [isChecklistNotasPanelOpen, setIsChecklistNotasPanelOpen] = useState(false);

    const [hideSendToRevision, setHideSendToRevision] = useState(false);
    const [isExecutingAction, setIsExecutingAction] = useState(false);

    const [downloadInProgress, setDownloadInProgress] = useState(false);

    useGetEdPResult(inputParam_ElementId, inputParam_EdPId, edpPrepareResult, forceGet_PrepareResult);
    useGetEdPResultDI(inputParam_EdPId, edpPrepareDIs);
    useGetEdPResultParties(inputParam_EdPId, edpPrepareParties, forceGet_PrepareParties);
    const [contract, setContract] = useState(null);
    useGetContractById((!isNullUndefined(edpPrepareHeader) ? edpPrepareHeader.contracT_ID : null), contract, setContract);
    const [edpPolinomioList, setEdpPolinomioList] = useState(null);
    useGetEdPPolinomios(inputParam_ElementId, inputParam_EdPId, edpPolinomioList, setEdpPolinomioList);

    useCargarVista(edpPrepareErrorValidations, edpPrepareHeader, (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin), edpPrepareManageButtons, forceGet_PrepareButtons);

    const onExportExcelClick = async () => {
        setDownloadInProgress(true);
        await exportEdP(inputParam_ElementId, inputParam_EdPId).then((response) => {
            if (!isNullUndefinedOrEmpty(response.data)) {
                saveByteArray(`Estado de pago ${edpPrepareHeader.contracT_CODE} (${edpPrepareHeader.nrO_EP}) ${moment(edpPrepareHeader.periodo).format("DD-MM-YYYY")}.xlsx`, base64ToArrayBuffer(response.data));
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationperformed']))
                setDownloadInProgress(false);
            }
            else {
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
                setDownloadInProgress(false)
            }
        }).catch(() => {
            dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
            setDownloadInProgress(false)
        });
    }

    const onExportChecklistClick = async () => {
        setDownloadInProgress(true);
        try {
            const checklistResponse = await getChecklistEP(inputParam_ElementId, inputParam_EdPId);
            await generateAndDownloadChecklistPDF(edpPrepareHeader, checklistResponse?.data?.data, contextSite.applicationRoles);
        }
        catch {
            dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
        }
        finally {
            setDownloadInProgress(false);
        }
    }

    const onOpenDynamicAprovePanel = () => {
        setIsDinamicIccLccPanelOpen(true)
        setCalloutVisibleIndex(`dynamic_rev_${enum_ENUM_TIPO_RESPUESTA.AAD}`)
    }

    const onExportPdfClick = async () => {
        setDownloadInProgress(true);

        let aux_edpPrepareHeader = cloneDeep(edpPrepareHeader);

        for (let index = 0; index < aux_edpPrepareHeader.l_etapas_revision.length; index++) {
            let revision = aux_edpPrepareHeader.l_etapas_revision[index].item_respuesta;
            if (!isNullUndefined(revision)) {
                const qrData = !isNullUndefinedOrEmpty(revision.fullname) && !isNullUndefinedOrEmpty(revision.fecha) ? `El usuario ${!isNullUndefinedOrEmpty(revision.fullname) ? revision.fullname : '-'} ha realizado la acción el día ${!isNullUndefinedOrEmpty(revision.fecha) ? revision.fecha : '-'}` : null;
                const image = !isNullUndefinedOrEmpty(qrData) ? await qrToPng(convettSignatureDatesToGMTLocal(qrData), 100) : null;
                aux_edpPrepareHeader.l_etapas_revision[index].firma = image;
            }
            else {
                aux_edpPrepareHeader.l_etapas_revision[index].firma = null;
            }
        }

        await generateAndDownloadPDF(aux_edpPrepareHeader, {data:edpPrepareParties},  {data:edpPrepareDIs}, {data:edpPrepareResult}, {data:contract}, edpPolinomioList, authGetClient(), contextSite.applicationRoles).then(() => {
            setDownloadInProgress(false);
        }).catch(() => {
            dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
            setDownloadInProgress(false)
        });
    }

    const onDeleteClick = () => {
        setIsExecutingAction(true);
        deleteEdP(inputParam_ElementId, inputParam_EdPId).then((response) => {
            if (response.data.succeeded) {
                setIsDeleted(true);
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationperformed']))
            }
            else {
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
            }
            setIsExecutingAction(false);
        }).catch(() => {
            dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
            setIsExecutingAction(false);
        });
    }

    const onPreAnularClick = () => {
        showDialog();
    }

    const onAnularClick = () => {
        setIsExecutingAction(true);
        anulateEdP(inputParam_ElementId, inputParam_EdPId).then((response) => {
            if (response.data.succeeded) {
                window.location.href = window.location.href;
                //dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationperformed']))
            }
            else {
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
            }
            setIsExecutingAction(false);
        }).catch(() => {
            dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
            setIsExecutingAction(false);
        });
    }
    
    const onEndRevisionClick = () => {
        setIsExecutingAction(true);

        revisionEndsEP(inputParam_ElementId, inputParam_EdPId, edpPrepareHeader.rolTipoRespuestaRevision).then(async (response) => {
            if (response.data.succeeded) {
                if (response.data.data.result) {
                    window.location.href = window.location.href;
                    /*dispatch(action_updateEdPPrepareForceGetHeader(true));
                    dispatch(action_updateEdPPrepareForceGetResult(true));
                    dispatch(action_updateEdPPrepareForceGetButtons(true));*/
                }
                else {
                
                    dispatch(action_updateEdPPrepareErrorValidations(response.data.data.l_validations))
                    setIsExecutingAction(false);
                }
            }
            else {
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
                setIsExecutingAction(false);
            }
        }).catch(() => {
            dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
            setIsExecutingAction(false);
        });
    }

    // "Terminar revisión" del AAD debe abrir primero el panel de notas del checklist; solo al guardar
    // ahí se ejecuta la acción real de terminar revisión. Esto es exclusivo de AMSA: para cualquier
    // otro cliente (o para ATO en AMSA) se comporta igual que siempre, sin pasar por el panel.
    const onTerminarRevisionClick = () => {
        const filaPendiente = edpPrepareHeader?.l_etapas_revision?.find(x => x.id === edpPrepareHeader.rolMatrizEtapaFlujo && x.highlight === true);

        if (esClienteAmsa && filaPendiente?.rol === 'AAD') {
            setIsChecklistNotasPanelOpen(true);
        }
        else {
            onEndRevisionClick();
        }
    }

    const onNotasGuardadasAntesDeTerminarRevision = async () => {
        setIsChecklistNotasPanelOpen(false);
        onEndRevisionClick();
    }

    const onSendToRevisionClick = async () => {
        setHideSendToRevision(true);

        await revisionEP(inputParam_ElementId, inputParam_EdPId).then(async (response) => {
            if (response.data.succeeded) {
                if (response.data.data.result) {
                    window.location.href = window.location.href;
                    /*dispatch(action_updateEdPPrepareForceGetHeader(true));
                    dispatch(action_updateEdPPrepareForceGetResult(true));
                    dispatch(action_updateEdPPrepareForceGetButtons(true));*/
                }
                else {
                    dispatch(action_updateEdPPrepareErrorValidations(response.data.data.l_validations))
                    setHideSendToRevision(false);
                }
            }
            else {
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
                setHideSendToRevision(false);
            }
        }).catch(() => {
            dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']))
            setHideSendToRevision(false);
        });
    }

    const onViewPartieComment = (partie) => {
        setSelectedPartieToComment(partie);
        setIsPartieCommentPanelOpen(!isPartieCommentPanelOpen)
    }

    const onOpenIngresoDatosEdPPanelClick = () => {
        setIsIngresoDatosPanelOpen(!isIngresoDatosPanelOpen)
    }

    const getFirstTotalRow = () => {
        const fisrtTotalRow = edpPrepareResult.find(x => x.listadO_PARTIDA_CODIGO === '^')
        return  <>
                    <th className='table-without-border'>&nbsp;</th>
                    <th data-cell={'B1-7'} className='text-center cell-blue-dark-font-white' colSpan={7}>Total</th>
                    <th data-cell={'B8'}   className='text-center cell-blue-dark-font-white' >{fisrtTotalRow.montO_TOTCONT_MONTO_BASE_MC.toLocaleString()}</th>
                    <th className='table-without-border'>&nbsp;</th>
                    <th data-cell={'C1-3'} className='text-center cell-blue-dark-font-white' colSpan={3}>&nbsp;</th>
                    <th data-cell={'C4'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.eP_MES_MONTO_BASE_MC.toLocaleString()}</th>
                    <th data-cell={'C5-6'} className='text-center cell-blue-dark-font-white' colSpan={2}>&nbsp;</th>
                    <th data-cell={'C7'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.eP_MES_REAJUSTE_MC.toLocaleString()}</th>
                    <th data-cell={'C8'}   className='text-center cell-blue-dark-font-white'>&nbsp;</th>
                    <th data-cell={'C9'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.eP_MES_DIFERENCIA_TC_MC.toLocaleString()}</th>
                    <th data-cell={'C10'}  className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.eP_MES_MONTO_PAGO_MC.toLocaleString()}</th>
                    <th className='table-without-border'>&nbsp;</th>
                    <th data-cell={'D1-2'} className='text-center cell-blue-dark-font-white' colSpan={2}>&nbsp;</th>
                    <th data-cell={'D3'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.acuM_ANTERIOR_MONTO_BASE_MC.toLocaleString()}</th>
                    <th data-cell={'D4'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.acuM_ANTERIOR_REAJUSTE_MC.toLocaleString()}</th>
                    <th data-cell={'D5'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.acuM_ANTERIOR_DIFERENCIA_TC_MC.toLocaleString()}</th>
                    <th data-cell={'D6'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.acuM_ANTERIOR_MONTO_PAGO_MC.toLocaleString()}</th>
                    <th data-cell={'E1-2'} className='text-center cell-blue-dark-font-white' colSpan={2}>&nbsp;</th>
                    <th data-cell={'E3'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.acuM_MONTO_BASE_MC.toLocaleString()}</th>
                    <th data-cell={'E4'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.acuM_REAJUSTE_MC.toLocaleString()}</th>
                    <th data-cell={'E5'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.acuM_DIFERENCIA_TC_MC.toLocaleString()}</th>
                    <th data-cell={'E6'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.acuM_MONTO_PAGO_MC.toLocaleString()}</th>
                    <th data-cell={'F1-2'} className='text-center cell-blue-dark-font-white' colSpan={2}>&nbsp;</th>
                    <th data-cell={'F3'}   className='text-center cell-blue-dark-font-white'>{fisrtTotalRow.saldO_MONTO_BASE_MC.toLocaleString()}</th>
                    <th data-cell={'G1'}   className='text-center cell-blue-dark-font-white'></th>
                </>
    }

    const getPartieRow = (partie) => {
        if (partie.id > 0) {
            return  <>
                <td className='table-without-border'>&nbsp;</td>
                <td data-cell={'B1'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.montO_TOTCONT_UNIDAD}</td>
                <td data-cell={'B2'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.montO_TOTCONT_CANTIDAD_SERVICIOS.toLocaleString()}</td>
                <td data-cell={'B3'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.montO_TOTCONT_CANTIDAD_CONCEPTO_PAGO.toLocaleString()}</td>
                <td data-cell={'B4'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.montO_TOTCONT_MONEDA_PARTIDA}</td>
                <td data-cell={'B5'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.montO_TOTCONT_PRECIO_UNITARIO.toLocaleString()}</td>
                <td data-cell={'B6'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.montO_TOTCONT_MONTO_BASE_MP.toLocaleString()}</td>
                <td data-cell={'B7'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.montO_TOTCONT_TIPO_CAMBIO_BASE.toLocaleString()}</td>
                <td data-cell={'B8'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.montO_TOTCONT_MONTO_BASE_MC.toLocaleString()}</td>
                <td className='table-without-border'>&nbsp;</td>
                <td data-cell={'C1'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.eP_MES_CANTIDAD_SERVICIOS.toLocaleString()}</td>
                <td data-cell={'C2'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.eP_MES_CANTIDAD_CONCEPTO_PAGO.toLocaleString()}</td>
                <td data-cell={'C3'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.eP_MES_MONTO_BASE_MP.toLocaleString()}</td>
                <td data-cell={'C4'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.eP_MES_MONTO_BASE_MC.toLocaleString()}</td>
                <td data-cell={'C5'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.eP_MES_FACTOR_REAJUSTE.toLocaleString()}</td>
                <td data-cell={'C6'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.eP_MES_REAJUSTE_MP.toLocaleString()}</td>
                <td data-cell={'C7'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.eP_MES_REAJUSTE_MC.toLocaleString()}</td>
                <td data-cell={'C8'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.eP_MES_TIPO_CAMBIO.toLocaleString()}</td>
                <td data-cell={'C9'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.eP_MES_DIFERENCIA_TC_MC.toLocaleString()}</td>
                <td data-cell={'C10'}  className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.eP_MES_MONTO_PAGO_MC.toLocaleString()}</td>
                <td className='table-without-border'>&nbsp;</td>
                <td data-cell={'D1'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_ANTERIOR_CANTIDAD_SERVICIOS.toLocaleString()}</td>
                <td data-cell={'D2'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_ANTERIOR_CANTIDAD_CONCEPTO_PAGO.toLocaleString()}</td>
                <td data-cell={'D3'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_ANTERIOR_MONTO_BASE_MC.toLocaleString()}</td>
                <td data-cell={'D4'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_ANTERIOR_REAJUSTE_MC.toLocaleString()}</td>
                <td data-cell={'D5'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_ANTERIOR_DIFERENCIA_TC_MC.toLocaleString()}</td>
                <td data-cell={'D6'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_ANTERIOR_MONTO_PAGO_MC.toLocaleString()}</td>
                <td data-cell={'E1'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_CANTIDAD_SERVICIOS.toLocaleString()}</td>
                <td data-cell={'E2'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_CANTIDAD_CONCEPTO_PAGO.toLocaleString()}</td>
                <td data-cell={'E3'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_MONTO_BASE_MC.toLocaleString()}</td>
                <td data-cell={'E4'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_REAJUSTE_MC.toLocaleString()}</td>
                <td data-cell={'E5'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_DIFERENCIA_TC_MC.toLocaleString()}</td>
                <td data-cell={'E6'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.acuM_MONTO_PAGO_MC.toLocaleString()}</td>
                <td data-cell={'F1'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.saldO_CANTIDAD_SERVICIOS.toLocaleString()}</td>
                <td data-cell={'F2'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.saldO_CANTIDAD_CONCEPTO_PAGO.toLocaleString()}</td>
                <td data-cell={'F3'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.saldO_MONTO_BASE_MC.toLocaleString()}</td>
                <td data-cell={'G1'}   className={`${ !isNullUndefinedOrEmptyOrZero(partie.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-without-border text-end`}>{partie.codigO_INTERNO}</td>
            </>
        }
        else if (partie.listadO_PARTIDA_CODIGO.indexOf('#') !== -1) {
            return  <>
                <td className='table-without-border'>&nbsp;</td>
                <td data-cell={'B1-7'} className='cabecera-lateral text-end' colSpan={7}></td>
                <td data-cell={'B8'}   className='cabecera-lateral text-end'>{partie.montO_TOTCONT_MONTO_BASE_MC.toLocaleString()}</td>
                <td className='table-without-border'>&nbsp;</td>
                <td data-cell={'C1-3'} className='cabecera-lateral text-end' colSpan={3}>&nbsp;</td>
                <td data-cell={'C4'}   className='cabecera-lateral text-end'>{partie.eP_MES_MONTO_BASE_MC.toLocaleString()}</td>
                <td data-cell={'C5-6'} className='cabecera-lateral text-end' colSpan={2}>&nbsp;</td>
                <td data-cell={'C7'}   className='cabecera-lateral text-end'>{partie.eP_MES_REAJUSTE_MC.toLocaleString()}</td>
                <td data-cell={'C8'}   className='cabecera-lateral text-end'>&nbsp;</td>
                <td data-cell={'C9'}   className='cabecera-lateral text-end'>{partie.eP_MES_DIFERENCIA_TC_MC.toLocaleString()}</td>
                <td data-cell={'C10'}  className='cabecera-lateral text-end'>{partie.eP_MES_MONTO_PAGO_MC.toLocaleString()}</td>
                <td className='table-without-border'>&nbsp;</td>
                <td data-cell={'D1-2'} className='cabecera-lateral text-end' colSpan={2}>&nbsp;</td>
                <td data-cell={'D3'}   className='cabecera-lateral text-end'>{partie.acuM_ANTERIOR_MONTO_BASE_MC.toLocaleString()}</td>
                <td data-cell={'D4'}   className='cabecera-lateral text-end'>{partie.acuM_ANTERIOR_REAJUSTE_MC.toLocaleString()}</td>
                <td data-cell={'D5'}   className='cabecera-lateral text-end'>{partie.acuM_ANTERIOR_DIFERENCIA_TC_MC.toLocaleString()}</td>
                <td data-cell={'D6'}   className='cabecera-lateral text-end'>{partie.acuM_ANTERIOR_MONTO_PAGO_MC.toLocaleString()}</td>
                <td data-cell={'E1-2'} className='cabecera-lateral text-end' colSpan={2}>&nbsp;</td>
                <td data-cell={'E3'}   className='cabecera-lateral text-end'>{partie.acuM_MONTO_BASE_MC.toLocaleString()}</td>
                <td data-cell={'E4'}   className='cabecera-lateral text-end'>{partie.acuM_REAJUSTE_MC.toLocaleString()}</td>
                <td data-cell={'E5'}   className='cabecera-lateral text-end'>{partie.acuM_DIFERENCIA_TC_MC.toLocaleString()}</td>
                <td data-cell={'E6'}   className='cabecera-lateral text-end'>{partie.acuM_MONTO_PAGO_MC.toLocaleString()}</td>
                <td data-cell={'F1-2'} className='cabecera-lateral text-end' colSpan={2}>&nbsp;</td>
                <td data-cell={'F3'}   className='cabecera-lateral text-end'>{partie.saldO_MONTO_BASE_MC.toLocaleString()}</td>
                <td data-cell={'G1'}   className='cabecera-lateral text-end'>{partie.codigO_INTERNO}</td>
            </>
        }
    }

    const getDIRows = (partida) => {
        return <>
                    <tr data-row-index={'Nombres Incrementos - Deducciones - Izquierda'}><td colSpan={4} className='cabecera-lateral'><b>Incrementos y deducciones</b></td></tr>
                    <tr data-row-index={'Nombre Incremento - Izquierda'}><td colSpan={4} className='cabecera-lateral'><b>Incrementos</b></td></tr>
                    {
                        edpPrepareResult && edpPrepareResult.filter(x => x.listadO_PARTIDA_CODIGO === "ª" && x.dI_ID_COMPUESTA.indexOf('I|') !== -1).map((incremento, index) => (
                            <tr data-row-index={'Incrementos - Nombres - Izquierda'} key={index} className='h-100'>
                                <td colSpan={3} className='cell-grey-normal'>{incremento.partidA_CLASE_NEMO}</td>
                                <td className='cell-grey-normal d-flex h-100'>
                                    {
                                        (edpPrepareHeader && isNullUndefinedOrEmptyOrZero(incremento.subpartidA_ID)) ?
                                        <>
                                            {
                                                renderDiRevisionIcon(incremento, index, "i")
                                            }
                                        </> : <>&nbsp;</>
                                    }
                                </td>
                            </tr>
                        ))
                    }
                    <tr data-row-index={'Nombre Deducciones - Izquierda'}><td colSpan={4} className='cabecera-lateral'><b>Deducciones</b></td></tr>
                    {
                        edpPrepareResult && edpPrepareResult.filter(x => x.listadO_PARTIDA_CODIGO === "ª" && x.dI_ID_COMPUESTA.indexOf('D|') !== -1).map((deduccion, index) => (
                            <tr data-row-index={'Deducciones - Nombres - Izquierda'} key={index} className='h-100'>
                                <td colSpan={3} className='cell-grey-normal'>{deduccion.partidA_CLASE_NEMO}</td>
                                <td className='cell-grey-normal d-flex h-100'>
                                    {
                                        (edpPrepareHeader && isNullUndefinedOrEmptyOrZero(deduccion.subpartidA_ID)) ?
                                        <>
                                            {
                                                renderDiRevisionIcon(deduccion, index, "d")
                                            }
                                        </>: <>&nbsp;</>
                                    }
                                </td>
                            </tr>
                        ))
                    }
                </>
    }

    const getMiddleTotalRow = () => {
        return  <tr data-row-index={'Totalizador Intermedio - Derecha'} className='cell-blue-dark-font-white'>
                    {
                        edpPrepareResult && edpPrepareResult.filter(x => x.listadO_PARTIDA_CODIGO.indexOf('*') !== -1).map((totalizador, index) => (
                        <React.Fragment key={index}>
                            <td className='table-without-border'>&nbsp;</td>
                            <td data-cell={'B1-7'} colSpan={7} className='text-end'>Total</td>
                            <td data-cell={'B8'} className='text-end'>{totalizador.montO_TOTCONT_MONTO_BASE_MC.toLocaleString()}</td>
                            <td className='table-without-border'>&nbsp;</td>
                            <td data-cell={'C1-3'} colSpan={3} className='text-end'>&nbsp;</td>
                            <td data-cell={'C4'}   className='text-end'>{totalizador.eP_MES_MONTO_BASE_MC.toLocaleString()}</td>
                            <td data-cell={'C5-6'} colSpan={2} className='text-end'>&nbsp;</td>
                            <td data-cell={'C7'}   className='text-end'>{totalizador.eP_MES_REAJUSTE_MC.toLocaleString()}</td>
                            <td data-cell={'C8'}   className='text-end'>&nbsp;</td>
                            <td data-cell={'C9'}   className='text-end'>{totalizador.eP_MES_DIFERENCIA_TC_MC.toLocaleString()}</td>
                            <td data-cell={'C10'}  className='text-end'>{totalizador.eP_MES_MONTO_PAGO_MC.toLocaleString()}</td>
                            <td className='table-without-border'>&nbsp;</td>
                            <td data-cell={'D1-2'} colSpan={2} className='text-end'>&nbsp;</td>
                            <td data-cell={'D3'}   className='text-end'>{totalizador.acuM_ANTERIOR_MONTO_BASE_MC.toLocaleString()}</td>
                            <td data-cell={'D4'}   className='text-end'>{totalizador.acuM_ANTERIOR_REAJUSTE_MC.toLocaleString()}</td>
                            <td data-cell={'D5'}   className='text-end'>{totalizador.acuM_ANTERIOR_DIFERENCIA_TC_MC.toLocaleString()}</td>
                            <td data-cell={'D6'}   className='text-end'>{totalizador.acuM_ANTERIOR_MONTO_PAGO_MC.toLocaleString()}</td>
                            <td data-cell={'E1-2'} colSpan={2} className='text-end'>&nbsp;</td>
                            <td data-cell={'E3'}   className='text-end'>{totalizador.acuM_MONTO_BASE_MC.toLocaleString()}</td>
                            <td data-cell={'E4'}   className='text-end'>{totalizador.acuM_REAJUSTE_MC.toLocaleString()}</td>
                            <td data-cell={'E5'}   className='text-end'>{totalizador.acuM_DIFERENCIA_TC_MC.toLocaleString()}</td>
                            <td data-cell={'E6'}   className='text-end'>{totalizador.acuM_MONTO_PAGO_MC.toLocaleString()}</td>
                            <td data-cell={'F1-2'} colSpan={2} className='text-end'>&nbsp;</td>
                            <td data-cell={'F3'}   className='text-end'>{totalizador.saldO_MONTO_BASE_MC.toLocaleString()}</td>
                            <td data-cell={'G1'}   className='text-end'>{totalizador.codigO_INTERNO}</td>
                        </React.Fragment>
                        ))
                    }
                </tr>
    }

    const getIncrementosDediccionesRows = () => {
        return  <>
                    <tr data-row-index={'Totales Incrementos - Deducciones - Derecha'}>
                        {Array.from({ length: 34 }, (_, i) => (
                            <React.Fragment key={i}>
                                {
                                    (i === 0 || i === 8 || i === 18) &&
                                    <td className='table-without-border'>&nbsp;</td>
                                }
                                {
                                    (i === 17) &&
                                    <td data-cell={"1.1"} className='cabecera-lateral text-end'>{edpPrepareResult.find(x => x.listadO_PARTIDA_CODIGO === "¤").eP_MES_MONTO_PAGO_MC.toLocaleString()}</td>
                                }
                                {
                                    (i === 23) &&
                                    <td data-cell={"2.2"} className='cabecera-lateral text-end'>{edpPrepareResult.find(x => x.listadO_PARTIDA_CODIGO === "¤").acuM_ANTERIOR_MONTO_PAGO_MC.toLocaleString()}</td>
                                }
                                {
                                    (i === 29) &&
                                    <td data-cell={"3.3"} className='cabecera-lateral text-end'>{edpPrepareResult.find(x => x.listadO_PARTIDA_CODIGO === "¤").acuM_MONTO_PAGO_MC.toLocaleString()}</td>
                                }
                                {
                                    (i !== 17 && i !== 23 && i !== 29) &&
                                    <td className='cabecera-lateral-without-border'>{''}</td>
                                }
                            </React.Fragment>
                        ))}
                    </tr>
                    <tr data-row-index={'Totales Incremento - Derecha'}>
                        {Array.from({ length: 34 }, (_, i) => (
                            <React.Fragment key={i}>
                                {
                                    (i === 0 || i === 8 || i === 18) &&
                                    <td key={i} className='table-without-border'>&nbsp;</td>
                                }
                                {
                                    (i === 17) &&
                                    <td data-cell={"1"} className='cabecera-lateral text-end'>{edpPrepareResult.find(x => x.listadO_PARTIDA_CODIGO === "~" && x.partidA_CLASE_NEMO === "Incrementos").eP_MES_MONTO_PAGO_MC.toLocaleString()}</td>
                                }
                                {
                                    (i === 23) &&
                                    <td data-cell={"2"} className='cabecera-lateral text-end'>{edpPrepareResult.find(x => x.listadO_PARTIDA_CODIGO === "~" && x.partidA_CLASE_NEMO === "Incrementos").acuM_ANTERIOR_MONTO_PAGO_MC.toLocaleString()}</td>
                                }
                                {
                                    (i === 29) &&
                                    <td data-cell={"3"} className='cabecera-lateral text-end'>{edpPrepareResult.find(x => x.listadO_PARTIDA_CODIGO === "~" && x.partidA_CLASE_NEMO === "Incrementos").acuM_MONTO_PAGO_MC.toLocaleString()}</td>
                                }
                                {
                                    (i !== 17 && i !== 23 && i !== 29) &&
                                    <td className='cabecera-lateral-without-border'>{''}</td>
                                }
                            </React.Fragment>
                        ))}
                    </tr>
                    {
                        edpPrepareResult && edpPrepareResult.filter(x => x.listadO_PARTIDA_CODIGO === "ª" && x.dI_ID_COMPUESTA.indexOf('I|') !== -1).map((incremento, index) => (
                        <tr key={index}>
                            {Array.from({ length: 34 }, (_, i) => (
                                <React.Fragment key={i}>
                                    {
                                        (i === 0 || i === 8 || i === 18) &&
                                        <td className='table-without-border'>&nbsp;</td>
                                    }
                                    {
                                        (i === 17) &&
                                        <td data-cell={"A1"} data-index={index} className='cell-grey-normal text-end'>{incremento.eP_MES_MONTO_PAGO_MC.toLocaleString()}</td>
                                    }
                                    {
                                        (i === 23) &&
                                        <td data-cell={"A2"} data-index={index} className='cell-grey-normal text-end'>{incremento.acuM_ANTERIOR_MONTO_PAGO_MC.toLocaleString()}</td>
                                    }
                                    {
                                        (i === 29) &&
                                        <td data-cell={"A3"} data-index={index} className='cell-grey-normal text-end'>{incremento.acuM_MONTO_PAGO_MC.toLocaleString()}</td>
                                    }
                                    {
                                        (i !== 17 && i !== 23  && i !== 29) &&
                                        <td data-index={index} className='cell-without-border'>{''}</td>
                                    }
                                </React.Fragment>
                            ))}
                        </tr>
                        ))
                    }
                    <tr data-row-index={'Totales Deducciones - Derecha'}>
                        {Array.from({ length: 34 }, (_, i) => (
                            <React.Fragment key={i}>
                                {
                                    (i === 0 || i === 8 || i === 18) &&
                                    <td className='table-without-border'>&nbsp;</td>
                                }
                                {
                                    (i === 17) &&
                                    <td data-cell={"B1"} className='cabecera-lateral text-end'>{edpPrepareResult.find(x => x.listadO_PARTIDA_CODIGO === "~" && x.partidA_CLASE_NEMO === "Deducciones").eP_MES_MONTO_PAGO_MC.toLocaleString()}</td>
                                }
                                {
                                    (i === 23) &&
                                    <td data-cell={"B2"} className='cabecera-lateral text-end'>{edpPrepareResult.find(x => x.listadO_PARTIDA_CODIGO === "~" && x.partidA_CLASE_NEMO === "Deducciones").acuM_ANTERIOR_MONTO_PAGO_MC.toLocaleString()}</td>
                                }
                                {
                                    (i === 29) &&
                                    <td data-cell={"B3"} className='cabecera-lateral text-end'>{edpPrepareResult.find(x => x.listadO_PARTIDA_CODIGO === "~" && x.partidA_CLASE_NEMO === "Deducciones").acuM_MONTO_PAGO_MC.toLocaleString()}</td>
                                }
                                {
                                    (i !== 17 && i !== 23 && i !== 29) &&
                                    <td className='cabecera-lateral-without-border'>{''}</td>
                                }
                            </React.Fragment>
                        ))}
                    </tr>
                    {
                        edpPrepareResult && edpPrepareResult.filter(x => x.listadO_PARTIDA_CODIGO === "ª" && x.dI_ID_COMPUESTA.indexOf('D|') !== -1).map((deduccion, index) => (
                            <tr key={index}>
                                {Array.from({ length: 34 }, (_, i) => (
                                    <React.Fragment key={i}>
                                        {
                                            (i === 0 || i === 8 || i === 18) &&
                                            <td className='table-without-border'>&nbsp;</td>
                                        }
                                        {
                                            (i === 17) &&
                                            <td data-index={index} className='cell-grey-normal text-end'>{deduccion.eP_MES_MONTO_PAGO_MC.toLocaleString()}</td>
                                        }
                                        {
                                            (i === 23) &&
                                            <td data-index={index} className='cell-grey-normal text-end'>{deduccion.acuM_ANTERIOR_MONTO_PAGO_MC.toLocaleString()}</td>
                                        }
                                        {
                                            (i === 29) &&
                                            <td data-index={index} className='cell-grey-normal text-end'>{deduccion.acuM_MONTO_PAGO_MC.toLocaleString()}</td>
                                        }
                                        {
                                            (i !== 17 && i !== 23 && i !== 29) &&
                                            <td data-index={index} className='cell-without-border'>{''}</td>
                                        }
                                    </React.Fragment>
                                ))}
                            </tr>
                        ))
                    }
                </>
    }

    const getFinalTotalRow = () => {
        return  <tr data-row-index={'Totalizador Final - Derecha'} className='cell-blue-dark-font-white'>
                    {
                        edpPrepareResult && edpPrepareResult.filter(x => x.listadO_PARTIDA_CODIGO === '@').map((totalizador, index) => (
                        <React.Fragment key={index}>
                            <td className='table-without-border'>&nbsp;</td>
                            <td data-cell={'B1-B8'} colSpan={8}>&nbsp;</td>
                            <td className='table-without-border'>&nbsp;</td>
                            <td data-cell={'C1-C9'} colSpan={9} className='text-end'>Monto a Pagar</td>
                            <td data-cell={'C10'}  className='text-end'>{totalizador.eP_MES_MONTO_PAGO_MC.toLocaleString()}</td>
                            <td className='table-without-border'>&nbsp;</td>
                            <td data-cell={'D1-D6'} colSpan={6} className='text-end'>{totalizador.acuM_ANTERIOR_MONTO_PAGO_MC.toLocaleString()}</td>
                            <td data-cell={'E1-E6'} colSpan={6} className='text-end'>{totalizador.acuM_MONTO_PAGO_MC.toLocaleString()}</td>
                            <td data-cell={'F1-CodInterno'} colSpan={4} className='text-end'>&nbsp;</td>
                        </React.Fragment>
                        ))
                    }
                </tr>
    }

    const handleRightTableScroll = () => {
        if (leftTableRef.current && rightTableRef.current) {
            leftTableRef.current.scrollTop = rightTableRef.current.scrollTop;
        }
    };

    const updateGlobalMessageLocally = (show) => {
        if (!show) {
            dispatch(action_updateEdPPrepareErrorValidations(null));
        }
    };

    const calculatePartieRevisionIconClass = (_partida, icono_revision) => {
        let partieIconClass = "";
        const paymentConceptAmount = edpPrepareResult.map(x => x.partidA_ID === _partida.partidA_ID ? x.eP_MES_CANTIDAD_CONCEPTO_PAGO : 0).reduce((a, b) => a + b, 0);

        if (paymentConceptAmount > 0) {
            partieIconClass = enum_ENUM_dIcono_Revision.find(x => x.key === icono_revision).value
        }
        else {
            partieIconClass = enum_ENUM_dIcono_Revision.find(x => x.key === enum_ENUM_ICONO_REVISION.VALOR_ZERO_DI).value
        }
        return partieIconClass;
    }

    const calculateDIRevisionIconClass = (_di, icono_revision) => {
        let partieIconClass = "";
        const paymentConceptAmount = edpPrepareResult.map(x => x.dI_ID_COMPUESTA === _di.dI_ID_COMPUESTA ? x.eP_MES_MONTO_PAGO_MC : 0).reduce((a, b) => a + b, 0);

        if (paymentConceptAmount > 0) {
            partieIconClass = enum_ENUM_dIcono_Revision.find(x => x.key === icono_revision).value
        }
        else {
            partieIconClass = enum_ENUM_dIcono_Revision.find(x => x.key === enum_ENUM_ICONO_REVISION.VALOR_ZERO_DI).value
        }
        return partieIconClass;
    }

    const renderPartieRevisionIcon = (partida, index) => {
        const diHeader = edpPrepareHeader.l_partidas_permiso.find(x => x.partidaId === partida.partidA_ID);
        const icono_revision = diHeader.iconoRevision;
        const etapaFlujoId = edpPrepareHeader.etapA_FLUJO_ID;
        const partieRevisionId = `revision_partida_${index}p`;

        // Verifica si se permiten comentarios/documentos en la etapa actual del flujo
        const canShowCommentControls = etapaFlujoId !== enum_ENUM_FLUJO_EP.ANULADO &&
            etapaFlujoId !== enum_ENUM_FLUJO_EP.APROBADO &&
            etapaFlujoId !== enum_ENUM_FLUJO_EP.APROBADO_COMUNICADO &&
            etapaFlujoId !== enum_ENUM_FLUJO_EP.HISTORICO;

        const commentControls = canShowCommentControls && (
            <>
                <IconButton
                    className='mt-2 mx-1'
                    iconProps={{ iconName: "Comment" }}
                    onClick={() => onViewPartieComment(partida)}
                    styles={{
                        root: {
                            height: '16px',
                            width: '16px',
                            color: (diHeader.hasCommnents ? "#17be17" : "#595959")
                        },
                        icon: { fontWeight: 'bolder !important' }
                    }}
                />
                <IconButton
                    className='mt-2 mx-1'
                    iconProps={{iconName: "Attach"}}
                    title='Documentos disponibles.'
                    onClick={() => onViewPartieComment(partida)}
                    styles={{
                        root: {
                            height: '16px',
                            width: '16px',
                            color: (diHeader.hasDocuments ? "#17be17" : "#595959")
                        },
                        icon: { fontWeight: 'bolder !important' }
                    }}
                />
            </>
        );

        // Salida temprana si no se encuentra en contexto de revisión
        if (icono_revision === enum_ENUM_ICONO_REVISION.NINGUNO || etapaFlujoId === enum_ENUM_FLUJO_EP.PREPARACION || partida.subpartidA_ID !== null) {
            return !isNullUndefinedOrEmptyOrNegative(icono_revision) ? commentControls : <>&nbsp;</>;
        }

        // Determina si el botón debe estar deshabilitado
        const isDisabledIconType = diHeader.iconoTipo === "div";
        const isDisabledStatus = [
            enum_ENUM_ICONO_REVISION.DESHABILITADO_SIN_REVISAR,
            enum_ENUM_ICONO_REVISION.DESHABILITADO_RECHAZADO,
            enum_ENUM_ICONO_REVISION.DESHABILITADO_APROBADO
        ].includes(icono_revision);
        
        const deshabilitar_boton = (_priv_canEditEdP ? false : isDisabledIconType) ? isDisabledStatus : false;

        // Obtiene la clase del ícono cacheada
        const iconClass = enum_ENUM_dIcono_Revision.find(x => x.key === icono_revision)?.value;
        const hasZeroAmount = isNullUndefinedOrEmptyOrZero(partida.eP_MES_CANTIDAD_CONCEPTO_PAGO) && 
                              isNullUndefinedOrEmptyOrZero(partida.eP_MES_CANTIDAD_SERVICIOS);

        // Cachea la búsqueda de etapa de revisión
        const revisionStage = edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'partida');

        // Renderiza botón inactivo cuando está deshabilitado
        if (deshabilitar_boton) {
            return (
                <>
                    <div type='button' id={partieRevisionId} className={`mt-2 mx-1 button-estados ${iconClass}`} />
                    {commentControls}
                </>
            );
        }

        const validateBlueClass = hasZeroAmount && edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.REVISION && edpPrepareHeader.l_partidas_permiso.find(x => x.partidaId === partida.partidA_ID).iconoRevision === enum_ENUM_ICONO_REVISION.SIN_REVISAR;
        
        // Renderiza botón interactivo con diálogo
        return (
            <>
                <input 
                    type='button' 
                    id={partieRevisionId}
                    title={validateBlueClass ? 'No presenta cantidades en el periodo' : undefined}
                    className={`mt-2 mx-1 button-estados ${validateBlueClass ? calculatePartieRevisionIconClass(partida, icono_revision) : iconClass}`}
                    onClick={() => setCalloutVisibleIndex(index+"p")} 
                />
                <ApprovePartieDiDialog
                    inputParam_ElementId={inputParam_ElementId}
                    inputParam_EdPId={inputParam_EdPId}
                    inputParam_DialogTitleText={t('data-lang-btn-reviewpartie')}
                    inputParam_TargetControlId={`#${partieRevisionId}`}
                    inputParam_IndexString={index + "p"}
                    inputParam_CalloutVisibleIndex={calloutVisibleIndex}
                    inputParam_SetCalloutVisibleIndex={setCalloutVisibleIndex}
                    inputParam_VerRevision={diHeader.verRevision}
                    inputParam_RolTipoRespuestaId={diHeader.rolTipoRespuestaRevision}
                    inputParam_RolMatrizEtapaFlujo={diHeader.rolMatrizEtapaFlujo}
                    inputParam_EstadoPagoPartidaId={partida.edP_PARTIDA_ID}
                    inputParam_PartidaId={partida.partidA_ID}
                    inputParam_EstadoPagoCompuestaDiId={"0"}
                    inputParam_Iteracion={edpPrepareHeader.iteracioN_EP}
                    inputParam_EditMode={edpPrepareHeader.puede_revisar_partidas_ep && diHeader.iconoTipo !== "div"}
                    inputParam_EdpIatrizEtapaId={revisionStage?.id ?? 0}
                    inputParam_TipoRespuestaId={revisionStage?.tipo_respuesta_id ?? 0}
                />
                {commentControls}
            </>
        );
    }

    const renderDiRevisionIcon = (di, index, i_o_d) => {
        const diHeader = edpPrepareHeader.l_partidas_permiso.find(x => x.dI_ID_COMPUESTA === di.dI_ID_COMPUESTA);
        const icono_revision = diHeader.iconoRevision;
        const etapaFlujoId = edpPrepareHeader.etapA_FLUJO_ID;
        const diRevisionId = `revision_di_${index}${i_o_d}`;

        // Verifica si se permiten comentarios/documentos en la etapa actual del flujo
        const canShowCommentControls = etapaFlujoId !== enum_ENUM_FLUJO_EP.ANULADO &&
            etapaFlujoId !== enum_ENUM_FLUJO_EP.APROBADO &&
            etapaFlujoId !== enum_ENUM_FLUJO_EP.APROBADO_COMUNICADO &&
            etapaFlujoId !== enum_ENUM_FLUJO_EP.HISTORICO;

        const commentControls = canShowCommentControls && (
            <>
                <IconButton
                    className='mt-2 mx-1'
                    iconProps={{iconName: "Comment"}}
                    onClick={() => onViewPartieComment(di)}
                    styles={{
                        root: {
                            height: '16px',
                            width: '16px',
                            color: (diHeader.hasCommnents ? "#17be17" : "#595959")
                        },
                        icon: { fontWeight: 'bolder !important' }
                    }}
                />
                <IconButton
                    className='mt-2 mx-1'
                    iconProps={{iconName: "Attach"}}
                    title='Documentos disponibles.'
                    onClick={() => onViewPartieComment(di)}
                    styles={{
                        root: {
                            height: '16px',
                            width: '16px',
                            color: (diHeader.hasDocuments ? "#17be17" : "#595959")
                        },
                        icon: { fontWeight: 'bolder !important' }
                    }}
                />
            </>
        );

        // Salida temprana si no se encuentra en contexto de revisión o el monto del DI es cero
        if (icono_revision === enum_ENUM_ICONO_REVISION.NINGUNO || 
            etapaFlujoId === enum_ENUM_FLUJO_EP.PREPARACION) {
            return !isNullUndefinedOrEmptyOrNegative(icono_revision) ? commentControls : <>&nbsp;</>;
        }

        // Determina si el botón debe estar deshabilitado
        const isDisabledIconType = diHeader.iconoTipo === "div";
        const isDisabledStatus = [
            enum_ENUM_ICONO_REVISION.DESHABILITADO_SIN_REVISAR,
            enum_ENUM_ICONO_REVISION.DESHABILITADO_RECHAZADO,
            enum_ENUM_ICONO_REVISION.DESHABILITADO_APROBADO
        ].includes(icono_revision);
        
        const deshabilitar_boton = (_priv_canEditEdP ? false : isDisabledIconType) ? isDisabledStatus : false;

        // Cachea la clase del ícono y etapa de revisión
        const iconClass = enum_ENUM_dIcono_Revision.find(x => x.key === icono_revision)?.value;
        const hasZeroAmount = isNullUndefinedOrEmptyOrZero(di.eP_MES_CANTIDAD_CONCEPTO_PAGO) && 
                              isNullUndefinedOrEmptyOrZero(di.eP_MES_CANTIDAD_SERVICIOS);
        const revisionStage = edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'di');
        const diTypeLabel = i_o_d === "d" ? t('data-lang-lbl-di-d-lower') : t('data-lang-lbl-di-i-lower');
        const dialogTitle = t('data-lang-btn-review2') + ' ' + diTypeLabel;

        const validateBlueClass = hasZeroAmount && edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.REVISION && edpPrepareHeader.l_partidas_permiso.find(x => x.dI_ID_COMPUESTA === di.dI_ID_COMPUESTA).iconoRevision === enum_ENUM_ICONO_REVISION.SIN_REVISAR;

        // Renderiza botón inactivo cuando está deshabilitado
        if (deshabilitar_boton) {
            return (
                <>
                    <div type='button' id={diRevisionId} className={`mt-2 mx-1 button-estados ${iconClass}`} />
                    {commentControls}
                </>
            );
        }

        // Renderiza botón interactivo con diálogo
        return (
            <>
                {
                    !(edpPrepareHeader.etapA_FLUJO_ID !== enum_ENUM_FLUJO_EP.PREPARACION && hasZeroAmount && diHeader.iconoRevision === enum_ENUM_ICONO_REVISION.DESHABILITADO_SIN_REVISAR) &&
                    <input 
                        type='button' 
                        id={diRevisionId} 
                        title={validateBlueClass ? 'No presenta cantidades en el periodo' : undefined}
                        className={`mt-2 mx-1 button-estados ${validateBlueClass ? calculateDIRevisionIconClass(di, icono_revision) : iconClass}`}
                        onClick={() => setCalloutVisibleIndex(index + i_o_d)} 
                    />
                }
                {
                    (edpPrepareHeader.etapA_FLUJO_ID !== enum_ENUM_FLUJO_EP.PREPARACION && hasZeroAmount && diHeader.iconoRevision === enum_ENUM_ICONO_REVISION.DESHABILITADO_SIN_REVISAR) &&
                    <div 
                        id={diRevisionId} 
                        className={`mt-2 mx-1 button-estados`}
                    />
                }
                <ApprovePartieDiDialog
                    inputParam_ElementId={inputParam_ElementId}
                    inputParam_EdPId={inputParam_EdPId}
                    inputParam_DialogTitleText={dialogTitle}
                    inputParam_TargetControlId={`#${diRevisionId}`}
                    inputParam_IndexString={index + i_o_d}
                    inputParam_CalloutVisibleIndex={calloutVisibleIndex}
                    inputParam_SetCalloutVisibleIndex={setCalloutVisibleIndex}
                    inputParam_VerRevision={diHeader.verRevision}
                    inputParam_RolTipoRespuestaId={diHeader.rolTipoRespuestaRevision}
                    inputParam_RolMatrizEtapaFlujo={diHeader.rolMatrizEtapaFlujo}
                    inputParam_EstadoPagoPartidaId={null}
                    inputParam_PartidaId={null}
                    inputParam_EstadoPagoCompuestaDiId={diHeader.dI_ID_COMPUESTA}
                    inputParam_Iteracion={edpPrepareHeader.iteracioN_EP}
                    inputParam_EditMode={edpPrepareHeader.puede_revisar_di_ep && diHeader.iconoTipo !== "div"}
                    inputParam_EdpIatrizEtapaId={revisionStage?.id ?? 0}
                    inputParam_TipoRespuestaId={revisionStage?.tipo_respuesta_id ?? 0}
                />
                {commentControls}
            </>
        );
    }

    // Visible desde que GST (rol AAD) termina su parte de la revisión — sin esperar a ICC/LCC (si
    // existen en esta variante de flujo) ni a que ADC apruebe — y se mantiene visible el resto del
    // proceso. Reutiliza el mismo mecanismo ya probado por el diagrama de flujo
    // (FlujoEdP/buildFlowNodesAndEdges.js): el grupo ATO/AAD deja de estar "highlight" (el paso
    // actualmente pendiente) en cuanto ambos terminan, sin importar si lo siguiente es ICC, LCC, ADC
    // o directo Aprobación en el flujo genérico. No se usa "respuesta" de la fila puntual porque
    // depende de que exista una respuesta general grabada para ese rol, algo que no se pudo confirmar
    // de forma confiable en todos los casos (ver conversación sobre el flujo con ICC/LCC).
    const grupoAtoAadPendiente = edpPrepareHeader?.l_etapas_revision?.some(x =>
        (x.rol === 'ATO' || x.rol === 'AAD') &&
        x.etapa_flujo_id === enum_ENUM_FLUJO_EP.REVISION &&
        x.highlight === true
    );
    const aadTerminoRevision = !isNullUndefined(edpPrepareHeader) &&
        edpPrepareHeader.etapA_FLUJO_ID >= enum_ENUM_FLUJO_EP.REVISION &&
        !grupoAtoAadPendiente;

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="d-flex h-100">
                <Card.Header className='d-flex'>     
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-boxname-edp')}</b></h4>
                    </Card.Title>
                    <ActionButton style={{position: "absolute", right: "0px"}} iconProps={{iconName: "View"}} text={t('data-lang-lbl-baktoedp')} onClick={() => __onGoToBoardEP(inputParam_ElementId)} />
                </Card.Header>
                <Card.Footer>
                    {
                        edpPrepareHeader && !isDeleted &&
                        <Row>
                            <Col className="col-dummy-white">
                                <MessageBoxInfoComplex
                                    inputParam_Width="100%"
                                    inputParam_TranslateText={true}
                                    inputParam_Display={!isNullUndefined(edpPrepareErrorValidations) && edpPrepareErrorValidations.length > 0}
                                    inputParam_ShowClose={true}
                                    inputParam_Message={ edpPrepareErrorValidations }
                                    inputParam_MessageType={__MessageTypes.WARNING}
                                    inputParam_CustomSetterMessage={true}
                                    inputParam_SetterMessage={updateGlobalMessageLocally}
                                />
                            </Col>
                            <Col className='col-auto me-auto d-flex'>
                                {
                                    edpPrepareManageButtons.btnIngresarDatosEPVisible &&
                                    <ActionButton className='me-1' iconProps={{iconName: "Add"}} text={'Ingresar datos EP'} onClick={onOpenIngresoDatosEdPPanelClick} />
                                }
                                {
                                    downloadInProgress &&
                                    <Loading
                                        inputParam_ShowLoading={true}
                                        inputParam_ShowText={false}
                                        inputParam_Width={'25px'}
                                        inputParam_Height={'25px'}
                                        inputParam_Left={""}
                                        inputParam_Style={{marginTop: 0}}
                                        inputParam_ColClassName={"me-2"}
                                        inputParam_MarginLeft={"auto"}
                                        inputParam_SpinnerSize={SpinnerSize.medium} />
                                }
                                {
                                    !downloadInProgress &&
                                    <ActionButton className='me-1' iconProps={{iconName: "CloudDownload"}} text={'Exportar a Excel'} onClick={ onExportExcelClick} />
                                }
                                {
                                    !downloadInProgress && esClienteAmsa && aadTerminoRevision &&
                                    <ActionButton className='me-1' iconProps={{iconName: "CloudDownload"}} text={'Exportar checklist'} onClick={ onExportChecklistClick } />
                                }
                                {
                                    (!downloadInProgress && contract && edpPrepareHeader && edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.APROBADO) &&
                                    <ActionButton className='me-1' iconProps={{iconName: "CloudDownload"}} text={'Exportar a PDF'} onClick={ onExportPdfClick} />
                                }
                                {
                                    !isExecutingAction &&
                                    <>
                                        {
                                            edpPrepareHeader.puede_eliminar_ep &&
                                            <ActionButton className='me-1' iconProps={{iconName: "Delete"}} text={'Eliminar'} onClick={onDeleteClick} />
                                        }
                                        {
                                            edpPrepareHeader.puede_anular_ep &&
                                            <ActionButton className='me-1' iconProps={{iconName: "ReceiptUndelivered"}} text={'Anular'} onClick={onPreAnularClick} />
                                        }
                                    </>
                                }
                                {
                                    edpPrepareHeader.puede_enviar_revision_ep && !hideSendToRevision &&
                                    <ActionButton className='me-1' iconProps={{iconName: "WaitlistConfirm"}} text={'Enviar a revisión'} onClick={onSendToRevisionClick} />
                                }
                                {
                                    hideSendToRevision &&
                                    <Loading
                                        inputParam_Style={{marginTop: 0}}
                                        inputParam_ShowLoading={true}
                                        inputParam_ShowText={true}
                                        inputParam_Text={t('data-lang-lbl-executing')}
                                        inputParam_Position="unset"
                                        inputParam_Width="20px"
                                        inputParam_Height="20px"
                                        inputParam_Vertical={false}
                                        inputParam_EjecutingTextClass={"ps-4"}
                                        inputParam_Left="87%"
                                        inputParam_Top="11px"
                                        inputParam_RootClass="pe-4"
                                    />
                                }
                                {
                                    edpPrepareHeader.puede_terminar_revision_ep && !isNullUndefined(edpPrepareHeader.l_etapas_revision.filter(x => x.revisionDinamica === true).find(x => x.id === edpPrepareHeader.rolMatrizEtapaFlujo && x.highlight === true)) && !isExecutingAction &&
                                    <>
                                        <ActionButton id={`${`revision_dynamic_${enum_ENUM_TIPO_RESPUESTA.AAD}`}`} className='me-1' iconProps={{iconName: "WaitlistConfirm"}} text={t('data-lang-btn-review2')} onClick={() => onOpenDynamicAprovePanel()} />
                                        <ApprovePartieDiPanel
                                            inputParam_ElementId={inputParam_ElementId}
                                            inputParam_EdPId={inputParam_EdPId}
                                            inputParam_DialogTitleText={t('data-lang-btn-review2')}
                                            inputParam_TargetControlId={`#${`revision_dynamic_${enum_ENUM_TIPO_RESPUESTA.AAD}`}`}
                                            inputParam_IndexString={`dynamic_rev_${enum_ENUM_TIPO_RESPUESTA.AAD}`}
                                            inputParam_CalloutVisibleIndex={calloutVisibleIndex}
                                            inputParam_IsPanelOpen={isDinamicIccLccPanelOpen}
                                            inputParam_SetterIsPanelOpen={setIsDinamicIccLccPanelOpen}
                                            inputParam_SetCalloutVisibleIndex={setCalloutVisibleIndex}
                                            inputParam_VerRevision={edpPrepareHeader.verRevision}
                                            inputParam_RolTipoRespuestaId={edpPrepareHeader.rolTipoRespuestaRevision}
                                            inputParam_RolMatrizEtapaFlujo={edpPrepareHeader.rolMatrizEtapaFlujo}
                                            inputParam_EstadoPagoPartidaId={null}
                                            inputParam_PartidaId={null}
                                            inputParam_EstadoPagoCompuestaDiId={null}
                                            inputParam_Iteracion={edpPrepareHeader.iteracioN_EP}
                                            inputParam_DisplayDirection={DirectionalHint.leftCenter}
                                            inputParam_RefreshPage={true}
                                            inputParam_EditMode={edpPrepareHeader.estadO_FLUJO_ID === enum_ENUM_FLUJO_EP.REVISION && edpPrepareHeader.puede_terminar_revision_ep === true}
                                            inputParam_EdpIatrizEtapaId={!isNullUndefined(edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'revision' && x.highlight === true)) ? edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'revision' && x.highlight === true).id : 0}
                                            inputParam_TipoRespuestaId={!isNullUndefined(edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'revision' && x.highlight === true)) ? edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'revision' && x.highlight === true).tipo_respuesta_id : 0}
                                        />
                                    </>
                                }
                                {
                                    edpPrepareHeader.puede_terminar_revision_ep && isNullUndefined(edpPrepareHeader.l_etapas_revision.filter(x => x.revisionDinamica === true).find(x => x.id === edpPrepareHeader.rolMatrizEtapaFlujo && x.highlight === true)) && !isExecutingAction &&
                                    <ActionButton className='me-1' iconProps={{iconName: "WaitlistConfirm"}} text={t('data-lang-btn-revisionend')} onClick={onTerminarRevisionClick} />
                                }
                                {
                                    isExecutingAction &&
                                    <Loading
                                        inputParam_Style={{marginTop: 0}}
                                        inputParam_ShowLoading={true}
                                        inputParam_ShowText={true}
                                        inputParam_Text={t('data-lang-lbl-executing')}
                                        inputParam_Position="unset"
                                        inputParam_Width="20px"
                                        inputParam_Height="20px"
                                        inputParam_Vertical={false}
                                        inputParam_ColClassName="my-auto"
                                        inputParam_EjecutingTextClass={"ps-4"}
                                        inputParam_Left="87%"
                                        inputParam_Top="11px"
                                        inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                                    />
                                }
                            </Col>
                        </Row>
                    }
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated w-100">
                    {
                        (firsLoadResult && firsLoadDI && firsLoadParties) && !isDeleted &&
                        <>
                            <div className="table-container w-100">
                                <Row className='ps-3' style={{ width: '100%'}}>
                                    <Col className='col-auto ms-auto m-0 p-0' ref={leftTableRef} style={{ height: '550px', overflow: 'hidden' }} >
                                        <table className="fixed-table h-1001">
                                            <thead style={{position: 'sticky', top: 0, backgroundColor: 'white', zIndex: '9'}}>
                                                <tr data-row-index={'Cabecera Principal - Primera Fila - Izquierda'} className='text-center'>
                                                    <th colSpan={4} className='cabecera-superior'>A. Listado de Partidas</th>
                                                </tr>
                                                <tr data-row-index={'Cabecera Principal - Segunda Fila - Izquierda'} className='text-center'>
                                                    <th className='cabecera-superior'>A1.<br/>Código<br/>&nbsp;</th>
                                                    <th className='cabecera-superior'>A2.<br/>Clase<br/>&nbsp;</th>
                                                    <th className='cabecera-superior'>A3.<br/>Descripción<br/>&nbsp;</th>
                                                    <th className='cabecera-superior'><br/>Revisión<br/>&nbsp;</th>
                                                </tr>
                                                <tr  data-row-index={'Totalizador Inicial - Izquierda'}>
                                                    <th className='text-center cell-blue-dark-font-white' colSpan={3}></th>
                                                    <th className='text-center cell-blue-dark-font-white-no-align'>{__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'ATO')}</th>
                                                </tr>
                                            </thead>
                                            <tbody className='h-100'>
                                                {
                                                    edpPrepareResult && edpPrepareResult.filter(x => x.id > 0 || x.listadO_PARTIDA_CODIGO.indexOf('#') !== -1).map((partida, index) => (
                                                        <React.Fragment key={index}>
                                                            {
                                                                partida.listadO_PARTIDA_CODIGO.indexOf('#') !== -1 &&
                                                                <tr data-row-index={'Categorias / Subcategorias'}>
                                                                    <td className='cabecera-lateral'>{partida.listadO_PARTIDA_CODIGO.replace("#", '')}</td>
                                                                    <td className='cabecera-lateral' colSpan={3}>{partida.partidA_CLASE_NEMO}</td>
                                                                </tr>
                                                            }
                                                            {
                                                                partida.id > 0 &&
                                                                <tr data-row-index={'Partes - SubPartes'} className='h-100'>
                                                                    <td className={`${ !isNullUndefinedOrEmptyOrZero(partida.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-grey-normal`}>{partida.partidA_CODIGO}</td>
                                                                    <td className={`${ !isNullUndefinedOrEmptyOrZero(partida.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-grey-normal`}>{partida.partidA_CLASE_NEMO}</td>
                                                                    <td className={`${ !isNullUndefinedOrEmptyOrZero(partida.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-grey-normal`} style={{whiteSpace: 'nowrap', overflow: 'hidden', maxWidth: '500px'}}>
                                                                        <TooltipHost
                                                                            overflowMode={TooltipOverflowMode.Self}
                                                                            content={ partida.listadO_PARTIDA_DESCRIPCION }
                                                                            onTooltipToggle={false}
                                                                            styles={{
                                                                                root: { display: 'block', position: "relative" },
                                                                            }}
                                                                        >
                                                                            {partida.listadO_PARTIDA_DESCRIPCION}
                                                                        </TooltipHost> 
                                                                    </td>
                                                                    <td className={`${ !isNullUndefinedOrEmptyOrZero(partida.subpartidA_ID) ? 'cell-resource-orange' : '' } cell-grey-normal text-center p-0 m-0 d-flex h-100`}>
                                                                        {
                                                                            (edpPrepareHeader && isNullUndefinedOrEmptyOrZero(partida.subpartidA_ID)) ?
                                                                            <>
                                                                                {
                                                                                    renderPartieRevisionIcon(partida, index)
                                                                                }
                                                                            </> : <>&nbsp;</>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                }
                                                <tr data-row-index={'Totalizador - Intermedio - Izquierda'}><td colSpan={3} className='cell-blue-dark-font-white'></td><td className='text-center cell-blue-dark-font-white-no-align'>{__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'AAD')}</td></tr>
                                                {
                                                    getDIRows()
                                                }
                                                <tr><td colSpan={4} className='cell-blue-dark-font-white'>&nbsp;</td></tr>
                                            </tbody>
                                        </table>
                                    </Col>
                                    <Col className='m-0 p-0' ref={rightTableRef} onScroll={handleRightTableScroll} style={{ height: '561px', overflow: 'auto' }}>
                                        <table className="scrollable-table">
                                            <thead style={{position: 'sticky', top: 0, backgroundColor: 'white'}}>
                                                <tr data-row-index={'Cabecera Principal - Primera Fila - Derecha'} className='text-center'>
                                                    <th className='table-without-border'>&nbsp;</th>
                                                    <th className='cabecera-superior' colSpan={8}>B. Monto Total del Contrato (Valor Base)</th>
                                                    <th className='table-without-border'>&nbsp;</th>
                                                    <th className='cabecera-superior' colSpan={10}>C. EP del Mes</th>
                                                    <th className='table-without-border'>&nbsp;</th>
                                                    <th className='cabecera-superior' colSpan={6}>D. Acumulado al EP Aprobado Anterior</th>
                                                    <th className='cabecera-superior' colSpan={6}>E. Acumulado hasta este EP</th>
                                                    <th className='cabecera-superior' colSpan={3}>F. Saldo</th>
                                                    <th className='cabecera-superior' rowSpan={2} style={{verticalAlign: "middle"}}>Código Interno</th>
                                                </tr>
                                                <tr data-row-index={'Cabecera Principal - Segunda Fila - Derecha'} className='text-center'>
                                                    <th className='table-without-border'>&nbsp;</th>
                                                    <th className='cabecera-superior'>B1.<br/>Unidad<br/>&nbsp;</th>
                                                    <th className='cabecera-superior'>B2.<br/>Cantidad<br/>Servicio</th>
                                                    <th className='cabecera-superior'>B3.<br/>Cantidad Concepto<br/>Pago</th>
                                                    <th className='cabecera-superior'>B4.<br/>Moneda de la<br/>partida</th>
                                                    <th className='cabecera-superior'>B5.<br/>Precio unitario<br/>&nbsp;</th>
                                                    <th className='cabecera-superior'>B6.<br/>Monto base<br/>(Moneda de la partida)</th>
                                                    <th className='cabecera-superior'>B7.<br/>Tipo de cambio<br/>Base</th>
                                                    <th className='cabecera-superior'>B8.<br/>Monto base<br/>(Moneda del contrato)</th>
                                                    <th className='table-without-border'>&nbsp;</th>
                                                    <th className='cabecera-superior'>C1.<br/>Cantidad<br/>Servicios</th>
                                                    <th className='cabecera-superior'>C2.<br/>Cantidad Concepto<br/>Pago</th>
                                                    <th className='cabecera-superior'>C3.<br/>Monto base<br/>(Moneda de la partida)</th>
                                                    <th className='cabecera-superior'>C4.<br/>Monto base<br/>(Moneda del contrato)</th>
                                                    <th className='cabecera-superior'>C5.<br/>Factor<br/>Reajuste</th>
                                                    <th className='cabecera-superior'>C6.<br/>Reajuste<br/>(Moneda de la partida)</th>
                                                    <th className='cabecera-superior'>C7.<br/>Reajuste<br/>(Moneda del contrato)</th>
                                                    <th className='cabecera-superior'>C8.<br/>Tipo de Cambio<br/>&nbsp;</th>
                                                    <th className='cabecera-superior'>C9.<br/>Diferencia T/C<br/>(Moneda del contrato)</th>
                                                    <th className='cabecera-superior'>C10.<br/>Monto a Pago<br/>(Moneda del contrato)</th>
                                                    <th className='table-without-border'>&nbsp;</th>
                                                    <th className='cabecera-superior'>D1.<br/>Cantidad<br/>Servicios</th>
                                                    <th className='cabecera-superior'>D2.<br/>Cantidad Concepto<br/>Pago</th>
                                                    <th className='cabecera-superior'>D3.<br/>Monto base<br/>(Moneda del contrato)</th>
                                                    <th className='cabecera-superior'>D4.<br/>Reajuste<br/>(Moneda del contrato)</th>
                                                    <th className='cabecera-superior'>D5.<br/>Diferencia T/C<br/>(Moneda del contrato)</th>
                                                    <th className='cabecera-superior'>D6.<br/>Monto a Pago<br/>(Moneda del contrato)</th>
                                                    <th className='cabecera-superior'>E1.<br/>Cantidad<br/>Servicios</th>
                                                    <th className='cabecera-superior'>E2.<br/>Cantidad Concepto<br/>Pago</th>
                                                    <th className='cabecera-superior'>E3.<br/>Monto base<br/>(Moneda del contrato)</th>
                                                    <th className='cabecera-superior'>E4.<br/>Reajuste<br/>(Moneda del contrato)</th>
                                                    <th className='cabecera-superior'>E5.<br/>Diferencia T/C<br/>(Moneda del contrato)</th>
                                                    <th className='cabecera-superior'>E6.<br/>Monto a Pago<br/>(Moneda del contrato)</th>
                                                    <th className='cabecera-superior'>F1.<br/>Cantidad<br/>Servicios</th>
                                                    <th className='cabecera-superior'>F2.<br/>Cantidad Concepto<br/>Pago</th>
                                                    <th className='cabecera-superior'>F3.<br/>Monto base<br/>(Moneda del contrato)</th>
                                                </tr>
                                                <tr data-row-index={'Totalizador Inicial - Derecha'}>
                                                    {
                                                        getFirstTotalRow()
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    edpPrepareResult && edpPrepareResult.filter(x => x.id > 0 || x.listadO_PARTIDA_CODIGO.indexOf('#') !== -1).map((partie, index) => (
                                                        <tr key={index}>
                                                        {
                                                            getPartieRow(partie)
                                                        }
                                                        </tr>
                                                    ))
                                                }
                                                { getMiddleTotalRow() }
                                                { getIncrementosDediccionesRows() }
                                                { getFinalTotalRow() }
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>
                            </div>
                            <Row className='mt-3'>
                                <Col className="col-dummy-white">
                                </Col>
                                <Col className='col-auto me-auto'>
                                    {
                                        edpPrepareHeader && edpPrepareManageButtons && edpPrepareManageButtons.tblhtmlRevisionDinamicaVisible &&
                                        <DynamicRevisionFlujoEdP
                                            inputParam_ElementId={inputParam_ElementId}
                                            inputParam_EdPId={inputParam_EdPId}
                                        />
                                    }
                                    {
                                        edpPrepareHeader && edpPrepareManageButtons && edpPrepareManageButtons.tblhtmlAprobarVisible &&
                                        <AprobacionFlujoEdP 
                                            inputParam_ElementId={inputParam_ElementId}
                                            inputParam_EdPId={inputParam_EdPId}
                                        />
                                    }
                                </Col>
                            </Row>
                        </>
                    }
                    {
                        (!firsLoadResult || !firsLoadDI || !firsLoadParties) &&
                        <Loading inputParam_ShowLoading={(!firsLoadResult || !firsLoadDI || !firsLoadParties)} />
                    }

                    {
                        isDeleted &&
                        <>{t('data-lang-msg-epdeleted')}</>
                    }
                </Card.Body>
            </Card>
            {
                isIngresoDatosPanelOpen &&
                <SidePanelIngresoEdP inputParam_ElementId={inputParam_ElementId} inputParam_EdPId={inputParam_EdPId} inputParam_IsPanelOpen={isIngresoDatosPanelOpen} inputParam_SetterIsPanelOpen={setIsIngresoDatosPanelOpen} />
            }
            {
                isPartieCommentPanelOpen &&
                <SidePanelViewEdPPartieComments inputParam_ElementId={inputParam_ElementId} inputParam_EdPId={inputParam_EdPId} inputParam_Partie={selectedPartieToComment} inputParam_IsPanelOpen={isPartieCommentPanelOpen} inputParam_SetterIsPanelOpen={setIsPartieCommentPanelOpen} inputParam_UserPropsKpi={inputParam_UserPropsKpi} />
            }
            {
                isChecklistNotasPanelOpen &&
                <SidePanelViewEdPChecklistNotas
                    inputParam_ElementId={inputParam_ElementId}
                    inputParam_EdPId={inputParam_EdPId}
                    inputParam_IsPanelOpen={isChecklistNotasPanelOpen}
                    inputParam_SetterIsPanelOpen={setIsChecklistNotasPanelOpen}
                    inputParam_UserPropsKpi={inputParam_UserPropsKpi}
                    inputParam_SaveButtonText={'Guardar y terminar revisión'}
                    inputParam_OnAfterSave={onNotasGuardadasAntesDeTerminarRevision}
                />
            }

            {
                isDialogVisible === true &&
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={hideDialog}
                    minWidth={740}
                    maxWidth={1000}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-boxname-warning'),
                    }}
                    modalProps={{
                        isBlocking: true,
                    }}
                >
                    <Row>
                        <Col xs={12} xl={12} className="mt-3">
                            <CLabel labelValue={ t('data-lang-msg-anulateedp') } /><br/>
                            <CLabel labelValue={ t('data-lang-msg-doyouwishcontinue') } className={'mt-3'} />
                        </Col>
                    </Row>
                    <DialogFooter>
                        {
                            !isExecutingAction &&
                            <Row>
                                <Col></Col>
                                <Col className='col-auto me-auto'>
                                    <PrimaryButton onClick={onAnularClick} text={t('data-lang-lbl-yes')} />
                                </Col>
                                <Col className='col-auto me-auto'>
                                    <DefaultButton onClick={hideDialog} text={t('data-lang-lbl-no')} />
                                </Col>
                            </Row>
                        }
                        {
                            isExecutingAction &&
                            <Loading
                                inputParam_Style={{marginTop: 0}}
                                inputParam_ShowLoading={true}
                                inputParam_ShowText={true}
                                inputParam_Text={t('data-lang-lbl-executing')}
                                inputParam_Position="unset"
                                inputParam_Width="20px"
                                inputParam_Height="20px"
                                inputParam_Vertical={false}
                                inputParam_ColClassName="my-auto"
                                inputParam_EjecutingTextClass={"ps-4"}
                                inputParam_Left="87%"
                                inputParam_Top="11px"
                                inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                            />
                        }
                    </DialogFooter>
                </Dialog>
            }
        </div>
    );
};

ResultadoEdP.propTypes = {
    inputParam_ElementId: PropTypes.number,
    inputParam_EdPId: PropTypes.number,
};

export default ResultadoEdP;